import React from 'react'
import {
  FooterContainer,
  FooterLogo,
  SocialLinks,
  SocialIcon,
  FooterContent,
  ContactSection,
  Address,
  ContactDetails,
  DesktopDivider,
  DividerBall,
  DividerLine,
  FooterLinks,
  MobileDivider,
  MobileDividerLine,
  AccreditationSection,
  AccreditationRow,
  CyberBadge,
  UkasBadge,
  AccreditationNumbers,
  HorizontalDivider,
  HorizontalLine,
  FooterBottom,
} from "./Styles";
import LogoImg from "../../assets/images/intellica.webp";
import CyberE from "../../assets/images/cyber-essentials-badge.svg";
import CyberEPlus from "../../assets/images/cyber-essentials-plus-badge.svg";
import UKASOne from "../../assets/images/UKAS22301.svg";
import UKASTwo from "../../assets/images/UKAS8320.svg";

const YouTubeIcon = () => (
  <svg
    viewBox="0 0 576 512"
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M549.7 124.1C543.5 100.4 524.9 81.8 501.4 75.5 458.9 64 288.1 64 288.1 64S117.3 64 74.7 75.5C51.2 81.8 32.7 100.4 26.4 124.1 15 167 15 256.4 15 256.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8 42.6 11.5 213.4 11.5 213.4 11.5s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6l0-162.4 142.7 81.2-142.7 81.2z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    viewBox="0 0 448 512"
    aria-hidden="true"
    fill="currentColor"
  >
    <path d="M100.3 448l-92.9 0 0-299.1 92.9 0 0 299.1zM53.8 108.1C24.1 108.1 0 83.5 0 53.8 0 39.5 5.7 25.9 15.8 15.8s23.8-15.8 38-15.8 27.9 5.7 38 15.8 15.8 23.8 15.8 38c0 29.7-24.1 54.3-53.8 54.3zM447.9 448l-92.7 0 0-145.6c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7l0 148.1-92.8 0 0-299.1 89.1 0 0 40.8 1.3 0c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3l0 164.3-.1 0z" />
  </svg>
);

export default function Footer() {
  return (
    <FooterContainer>
        <FooterLogo
          src={LogoImg}
          alt="Intellica"
        />

  <SocialLinks>
    <SocialIcon
      href="https://www.youtube.com/@intellicaltd"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Intellica on YouTube"
    >
      <YouTubeIcon />
    </SocialIcon>

    <SocialIcon
      href="https://www.linkedin.com/company/intellica-ltd"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Intellica on LinkedIn"
    >
      <LinkedInIcon />
    </SocialIcon>
  </SocialLinks>

      <FooterContent>
        <ContactSection>
          <DesktopDivider>
            <DividerBall />
            <DividerLine />
          </DesktopDivider>

          <div>
            <Address>
              Intellica Limited
              <br />
              The Royal Liver Building
              <br />
              Part Mezzanine Floor
              <br />
              Liverpool
              <br />
              L3 1HU
            </Address>

            <ContactDetails>
              <p>
                <a href="tel:01514337438" data-test="footerLink">0151 433 7438</a>
              </p>

              <p>
                <a href="mailto:hello@intellica.co.uk" data-test="footerLink">
                  hello@intellica.co.uk
                </a>
              </p>
            </ContactDetails>
          </div>

          <FooterLinks>
            <MobileDivider>
              <DividerBall />
              <MobileDividerLine />
              <DividerBall />
            </MobileDivider>

            <a href="https://intellica.co.uk/about/our-story/"
              target="_blank"
              rel="noopener noreferrer"
              data-test="footerLink"
              >About</a>
            <a href="https://intellica.co.uk/explore/"
              target="_blank"
              rel="noopener noreferrer"
              data-test="footerLink"
            >News</a>
            <a href="https://intellica.co.uk/contact/" target="_blank"
              rel="noopener noreferrer" data-test="footerLink">Contact</a>
            <a href="https://intellica.co.uk/legal/" target="_blank"
              rel="noopener noreferrer" data-test="footerLink">Legal</a>
            <a href="https://intellica.co.uk/privacy-and-cookies/" target="_blank"
              rel="noopener noreferrer" data-test="footerLink">Privacy</a>
            <a href="https://intellica.co.uk/accessibility/" target="_blank"
              rel="noopener noreferrer" data-test="footerLink">Accessibility</a>
            <a href="https://intellica.co.uk/accreditations/" target="_blank"
              rel="noopener noreferrer" data-test="footerLink">Accreditations</a>
          </FooterLinks>
        </ContactSection>

        <AccreditationSection>
          <HorizontalDivider>
            <DividerBall />
            <HorizontalLine />
          </HorizontalDivider>

          <AccreditationRow>
            <CyberBadge
              src={CyberE}
              alt="Cyber Essentials"
            />

            <CyberBadge
              src={CyberEPlus}
              alt="Cyber Essentials Plus"
            />
          </AccreditationRow>

          <AccreditationRow>
            <UkasBadge
              src={UKASOne}
              alt="UKAS ISO certifications"
            />

            <CyberBadge
              src={UKASTwo}
              alt="UKAS ISO 22301"
            />
          </AccreditationRow>

          <AccreditationNumbers>
            <div>
              <p>12278</p>
              <p>ISO 9001, ISO 27001, ISO 14001</p>
            </div>

            <div>
              <p>257328</p>
              <p>ISO 22301</p>
            </div>
          </AccreditationNumbers>
        </AccreditationSection>
      </FooterContent>

      <FooterBottom>
        <p>© 2026 Intellica</p>

        <p style={{ paddingTop: "30px"}}>
          Website by{" "}
          <a
            href="https://clay10.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            data-test="footerLink"
          >
            Clay10 Creative
          </a>
        </p>
      </FooterBottom>
    </FooterContainer>
  );
}